import { ModelRow } from "@mcleod/core/dist/src";
import { TableRowDisplayEvent } from "@mcleod/components";
import { FilterPanel } from "@mcleod/dispatch";
import { OrderPayablesUtil } from "../OrderPayablesUtil";
import { DriverSettlementTabLayout } from "./DriverSettlement";
import { AutogenLayoutDriverSettlementPendingReview } from "./autogen/AutogenLayoutDriverSettlementPendingReview";
import { RowDriverSettlementProfile } from "../../driver-settlement/src/models/ModelDriverSettlementProfile";

export class DriverSettlementPendingReview extends AutogenLayoutDriverSettlementPendingReview implements DriverSettlementTabLayout {
    public getProfileRow: () => RowDriverSettlementProfile;
    public filterPanel: FilterPanel;

    onLoad(): void | Promise<void> {
        this.filterPanel = new FilterPanel([], this.tableDriverSettlement, this.panelTaskFilters);
        this.tableDriverSettlement.addRowDisplayListener((event: TableRowDisplayEvent) => this.tableDriverSettlementOnRowDisplay(event));
    }

    getLayoutBaseFilter(row: ModelRow): boolean {
        return row.get("ready_to_pay_flag") == "N" && row.isNull("back_office_reason_code");
    }

    tableDriverSettlementOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        tableRow.forEveryChildComponent((component) => {
            OrderPayablesUtil.setTooltipContent(component, tableRow.data);
        });
        OrderPayablesUtil.setComponentDetails({
            tableRow: tableRow,
            profileRow: this.getProfileRow()
        });
    }
}
